<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.id"
        placeholder="请输入绘图ID"
        clearable
        size="small"
        class="param-input"
        style="width: 220px"
      ></el-input>
      <el-input
        v-model="params.bookName"
        placeholder="请输入绘图名称"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        placeholder="绘图类型"
        clearable
        size="small"
        v-model="params.type"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in types"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择绘图状态"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bookName"
        label="绘图名称"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.bookName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="绘图内容"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-button
            icon="el-icon-search"
            size="mini"
            @click="checkContent(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="绘图类型"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type == 1">文生图</div>
          <div v-else-if="scope.row.type == 2">图生图</div>
          <div v-else>--</div>
        </template>
      </el-table-column>

      <!-- <el-table-column
        prop="chatGptPrePrompt"
        label="ChatGpt预设提示词"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.chatGptPrePrompt || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="chatGptExample"
        label="ChatGpt案例"
        align="center"
        min-width="240"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.chatGptExample || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="prompt"
        label="默认正向"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.prompt || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="negativePrompt"
        label="默认反向"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.negativePrompt || "-" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="samplerIndex"
        label="采样方法"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.samplerIndex || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="steps"
        label="生成步数"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.steps || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="seed"
        label="种子随机数"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.seed || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="overrideSettings"
        label="绘图模型"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.overrideSettings || "" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cfgScale"
        label="相关性"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.cfgScale || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="width"
        label="图片宽度"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.width || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="height"
        label="图片宽度"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span class="tipBox">{{ scope.row.height || 0 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 2">绘制中</el-tag>
          <el-tag type="success" v-else-if="scope.row.status == 3"
            >绘制完成</el-tag
          >
          <el-tag type="info" v-else>等待绘制</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="draw(scope.row)"
            v-if="scope.row.status == 1"
            >绘图</el-button
          >
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>

    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1100px"
      @before-close="handleClose"
      @close="handleClose"
      class="dialogBox"
    >
      <el-form :model="form" label-width="140px" :rules="rules" ref="form">
        <el-form-item label="绘图名称" prop="bookName" style="width: 1000px">
          <el-input v-model="form.bookName"></el-input>
        </el-form-item>
        <el-form-item label="绘图内容" prop="content" style="width: 1000px">
          <el-input
            v-model="form.content"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 4 }"
            :placeholder="contentPlaceholder"
          ></el-input>
        </el-form-item>
        <el-form-item label="绘图类型" prop="cfgScale">
          <el-select v-model="form.type">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in types"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="GPT系统预设"
          prop="chatGptPrePrompt"
          style="width: 1000px"
        >
          <el-input
            v-model="form.chatGptPrePrompt"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 4 }"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="GPT案例"
          prop="chatGptExample"
          style="width: 1000px"
        >
          <el-input
            v-model="form.chatGptExample"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 4 }"
            placeholder="必须一问一答"
          ></el-input>
        </el-form-item>
        <el-form-item label="默认正向" prop="prompt" style="width: 1000px">
          <el-input
            v-model="form.prompt"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 4 }"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="默认反向"
          prop="negativePrompt"
          style="width: 1000px"
        >
          <el-input
            v-model="form.negativePrompt"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 4 }"
          ></el-input>
        </el-form-item>
        <div class="formBox">
          <el-form-item label="绘画模型" prop="mode">
            <el-select v-model="form.overrideSettings">
              <el-option
                :label="item.title"
                :value="item.title"
                v-for="item in sdModel"
                :key="item.title"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="相关性" prop="cfgScale">
            <el-slider
              v-model="form.cfgScale"
              :min="0"
              :max="15"
              style="width: 510px;"
            ></el-slider>
            <div style="margin-left: 10px;">{{ form.cfgScale }}</div>
          </el-form-item>
        </div>
        <div class="formBox">
          <el-form-item label="采样方法" prop="samplerIndex">
            <el-select v-model="form.samplerIndex">
              <el-option
                :label="item.name"
                :value="item.name"
                v-for="item in sampler"
                :key="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="步数" prop="steps">
            <el-slider
              v-model="form.steps"
              :min="0"
              :max="150"
              style="width: 190px;"
            ></el-slider>
            <div style="margin-left: 10px;">{{ form.steps }}</div>
          </el-form-item>
          <el-form-item label="随机种子" prop="seed">
            <el-input v-model="form.seed" type="number"></el-input>
          </el-form-item>
        </div>

        <div class="formBox">
          <el-form-item label="" style="flex: 1">
            <el-checkbox
              v-model="form.restoreFaces"
              style="margin-right: 120px;"
              >人脸修复</el-checkbox
            >
            <el-checkbox v-model="form.hrRepair">高清修复</el-checkbox>
          </el-form-item>
          <el-form-item
            label="高清采样步数"
            prop="stepCount"
            style="flex: 1"
            v-if="form.hrRepair"
          >
            <el-slider
              v-model="form.stepCount"
              :min="0"
              :max="150"
              style="width: 314px;"
            ></el-slider>
            <div style="margin-left: 10px;">{{ form.stepCount }}</div>
          </el-form-item>
        </div>

        <div class="formBox" v-if="form.hrRepair">
          <el-form-item label="放大算法" prop="mode">
            <el-select v-model="form.hrUpscaler" @change="changeUpScaler">
              <el-option
                :label="item.name"
                :value="item.name"
                v-for="item in upScaler"
                :key="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="放大比例" prop="stepCount">
            <el-slider
              v-model="form.scale"
              :min="0"
              :max="4"
              style="width: 130px;"
            ></el-slider>
            <div style="margin-left: 10px;">{{ form.scale }}</div>
          </el-form-item>
          <el-form-item label="重绘幅度" prop="stepCount">
            <el-slider
              v-model="form.stepCount"
              :min="0"
              :max="100"
              style="width: 224px;"
            ></el-slider>
            <div style="margin-left: 10px;">{{ form.stepCount }}</div>
          </el-form-item>
        </div>
        <div class="formBox">
          <el-form-item label="生成张数" prop="steps">
            <el-slider
              v-model="form.batchSize"
              :min="0"
              :max="100"
              style="width: 342px;"
            ></el-slider>
            <div style="margin-left: 10px;">{{ form.batchSize }}</div>
          </el-form-item>
          <el-form-item label="生成批次" prop="steps">
            <el-slider
              v-model="form.nIter"
              :min="0"
              :max="8"
              style="width: 342px;"
            ></el-slider>
            <div style="margin-left: 10px;">{{ form.nIter }}</div>
          </el-form-item>
        </div>
        <el-form-item label="图片宽度" prop="width">
          <el-slider
            v-model="form.width"
            :min="0"
            :max="2048"
            style="width: 844px"
          ></el-slider>
          <div style="margin-left: 10px;">{{ form.width }}</div>
        </el-form-item>
        <el-form-item label="图片高度" prop="height">
          <el-slider
            v-model="form.height"
            :min="0"
            :max="2048"
            style="width: 844px"
          ></el-slider>
          <div style="margin-left: 10px;">{{ form.height }}</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="绘图内容" :visible.sync="contentPop" width="60%">
      <el-table :data="drawContent" border>
        <el-table-column
          property="content"
          align="center"
          label="内容"
          min-width="300"
        >
          <template slot-scope="scope">
            {{ scope.row.content || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          property="image"
          align="center"
          label="图片"
          min-width="150"
        >
          <template slot-scope="scope">
            <div
              class="imgList"
              v-if="scope.row.image && scope.row.image.length"
            >
              <div class="imgItem" v-for="src in scope.row.image" :key="src">
                <img-load
                  v-if="src"
                  :width="'80px'"
                  :height="'80px'"
                  :src="imgUrl + src"
                ></img-load>
              </div>
            </div>
            <span v-else>暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="100"
          fixed="right"
          v-if="redrawSta"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-refresh"
              @click="redraw(scope.row)"
              >重绘</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      contentPlaceholder:
        "需要批量作画的内容，\n这里会根据回车键切分场景 \n一个场景对应一张图片， 所以一行内容不建议过多",
      samplingMethods: [
        { label: "Euler a", value: "Euler a" },
        { label: "Euler", value: "Euler" },
        { label: "LMS", value: "LMS" },
        { label: "Heun", value: "Heun" },
        { label: "DPM2", value: "DPM2" },
        { label: "DPM2 a", value: "DPM2 a" },
        { label: "DPM++2S a", value: "DPM++2S a" },
        { label: "DPM++ 2M", value: "DPM++ 2M" },
        { label: "DPM++ SDE", value: "DPM++ SDE" },
        { label: "DPM fast", value: "DPM fast" },
        { label: "DPM adaptive", value: "DPM adaptive" },
        { label: "LMS Karras", value: "LMS Karras" },
        { label: "DPM2 Karras", value: "DPM2 Karras" },
        { label: "DPM2 a Karras", value: "DPM2 a Karras" },
        { label: "DPM++ 2M Karras", value: "DPM++ 2M Karras" },
        { label: "DPM++ SDE Karras", value: "DPM++ SDE Karras" },
        { label: "DDIM", value: "DDIM" },
        { label: "PLMS", value: "PLMS" },
        { label: "UniPC", value: "UniPC" },
      ],
      samplingMethod: "",
      modeList: [
        { label: "None", value: "" },
        {
          label: "anything-v5-PrtTe.safetensors",
          value: "anything-v5-PrtTe.safetensors",
        },
      ],
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        bookName: undefined, // 名称
        type: undefined, // 类型
        status: undefined, // 状态
        id: undefined, // ID
      },
      rules: {
        bookName: [
          { required: true, message: "请输入绘图名称", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入绘图内容", trigger: "blur" },
        ],
        chatGptPrePrompt: [
          {
            required: true,
            message: "请输入ChatGpt预设提示词",
            trigger: "blur",
          },
        ],
        chatGptExample: [
          { required: true, message: "请输入ChatGpt案例", trigger: "blur" },
        ],
        prompt: [
          { required: true, message: "请输入正向提示词", trigger: "blur" },
        ],
        negativePrompt: [
          { required: true, message: "请输入反向提示词", trigger: "blur" },
        ],
      },
      imgUrl: baseConfig.imgUrl,
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        bookName: "", // 名称
        content: "", // 内容
        chatGptPrePrompt: "", // ChatGpt预设提示词
        chatGptExample: "", // ChatGpt案例
        prompt: "", // 提示词
        negativePrompt: "", // 反向提示词
        seed: -1, // 种子，随机数
        steps: 20, // 生成步数
        samplerIndex: "Euler", // 采样方法
        restoreFaces: false, // 脸部修复
        hrRepair: false, // 高清修复状态
        width: 512, // 宽度
        height: 512, // 高度
        overrideSettings: "None", // 绘图模型
        cfgScale: 7, // 关键词相关性
        nIter: 1,
        batchSize: 1,
        type: 1,
        scale: 0, // 放大比例
        hrUpscaler: "None", // 放大算法
      },
      defaultNegativePrompt: "", // 默认反向提示词
      defaultPrompt: "", // 默认正向提示词
      drawPromptExample: "", // 绘图GPT案例
      preDrawRolePrompt: "", // 绘图预角色提示词
      sdModel: [], // 绘图模型
      lora: [], // 人物模型
      sampler: [], // 采样方式
      script: [], // 脚本
      upScaler: [], // 放大算法模型
      statuses: [
        {
          label: "等待绘制",
          value: 1,
        },
        {
          label: "绘制中",
          value: 2,
        },
        {
          label: "绘制完成",
          value: 3,
        },
      ],
      types: [
        { label: "文生图", value: 1 },
        { label: "图生图", value: 2 },
      ],
      drawContent: null,
      contentPop: false,
      redrawSta: false,
    };
  },
  created() {
    // console.log('task-----------------')
    this.queryConfig();
    this.queryDrawConfig();
    this.getList();
  },
  methods: {
    queryDrawConfig() {
      API.queryDrawConfig()
        .then((res) => {
          if (res.code === 200 && res.data) {
            console.log(res);

            this.sdModel = [{ modelName: "None", title: "None" }].concat(
              res.data.sdModel || []
            );
            this.lora = res.data.lora || [];
            this.sampler = res.data.sampler || [];
            this.script = res.data.script || [];
            this.upScaler = res.data.upScaler || [];
          }
        })
        .catch(() => {});
    },
    changeUpScaler(name) {
      console.log(name);
      this.upScaler.forEach((item) => {
        if (item.name == name) {
          this.form.scale = item.scale;
        }
      });
      // console.log(item, "-------------");
    },
    queryConfig() {
      // console.log("=-=-=-=-=-")
      API.queryDefaultConfig()
        .then((res) => {
          if (res.code === 200 && res.data) {
            // console.log(res)
            let arr = res.data.list || [];
            // console.log(arr);
            arr.forEach((item) => {
              // console.log(item.type, '----')
              // console.log(item.type)
              if (item.type == "DefaultPromptNegativePrompt") {
                this.defaultNegativePrompt = item.value;
                // console.log(123123)
              } else if (item.type == "DefaultPrompt") {
                this.defaultPrompt = item.value;
              } else if (item.type == "DrawPromptExample") {
                this.drawPromptExample = item.value;
              } else if (item.type == "PreDrawRolePrompt") {
                this.preDrawRolePrompt = item.value;
              }
            });
          }
        })
        .catch(() => {});
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getDrawTaskList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          if (this.isBatch) {
            this.restoreCheckedState();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.form.icon = res.data.coverImg;
    },
    // 新增标签配置
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
        this.form.prompt = this.defaultPrompt;
        this.form.negativePrompt = this.defaultNegativePrompt;
        this.form.chatGptExample = this.drawPromptExample;
        this.form.chatGptPrePrompt = this.preDrawRolePrompt;
        this.changeUpScaler(this.form.hrUpscaler);
        console.log(this.form);
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.bookName = param.bookName; // 名称
        this.form.content = param.content; // 内容
        // this.form.hrUpscaler = param.hrUpscaler; // 放大算法
        this.form.chatGptPrePrompt = param.chatGptPrePrompt; // ChatGpt预设提示词
        this.form.chatGptExample = param.chatGptExample; // ChatGpt案例
        this.form.prompt = param.prompt; // 提示词
        this.form.negativePrompt = param.negativePrompt; // 反向提示词
        this.form.seed = param.seed; // 种子，随机数
        this.form.steps = param.steps; // 生成步数
        this.form.samplerIndex = param.samplerIndex; // 采样方法
        this.form.restoreFaces = param.restoreFaces; // 脸部修复
        this.form.hrRepair = param.hrRepair; // 脸部修复
        this.form.width = param.width; // 宽度
        this.form.height = param.height; // 高度
        this.form.overrideSettings = param.overrideSettings; // 绘图模型
        this.form.cfgScale = param.cfgScale; // 关键词相关性
        this.form.type = param.type; // 绘图类型
        this.changeUpScaler(this.form.hrUpscaler);
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // this.form.type = Number(this.form.type);
          API.addDrawTask(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    draw(row) {
      this.$confirm("您确定开始绘图？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = Object.assign(
          {},
          {
            ids: [row.id],
          }
        );
        API.startDraw(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "开始绘图",
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error("绘图失败");
            }
          })
          .catch(() => {
            this.flag = false;
            this.$message.error("绘图失败");
          });
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updateDrawTask(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.bookName}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delDrawTask(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.bookName = ""; // 名称
      this.form.content = ""; // 内容
      this.form.hrUpscaler = "None"; // 放大算法
      this.form.chatGptPrePrompt = ""; // ChatGpt预设提示词
      this.form.chatGptExample = ""; // ChatGpt案例
      this.form.prompt = ""; // 提示词
      this.form.negativePrompt = ""; // 反向提示词
      this.form.seed = -1; // 种子，随机数
      this.form.steps = 20; // 生成步数
      this.form.samplerIndex = "Euler"; // 采样方法
      this.form.restoreFaces = false; // 脸部修复
      this.form.hrRepair = false; // 高清修复
      this.form.width = 512; // 宽度
      this.form.height = 512; // 高度
      this.form.overrideSettings = "None"; // 绘图模型
      this.form.cfgScale = 7; // 关键词相关性
      this.form.type = 1; // 绘图类型
      this.form.scale = 0; // 放大比例
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // 查看内容
    checkContent(item) {
      this.drawContent = item.subPrompt;
      this.redrawSta = item.status != 1;
      this.contentPop = true;
    },
    // 重绘
    redraw(item) {
      this.$confirm("您确定重新绘图？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = Object.assign(
          {},
          {
            id: item.sid,
          }
        );
        API.reDraw(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "开始重绘",
                type: "success",
              });
              this.getList();
            } else {
              this.$message.error("重绘失败");
            }
          })
          .catch(() => {
            this.flag = false;
            this.$message.error("重绘失败");
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
.formBox {
  display: flex;
  align-items: center;
}
.dialogBox {
  // /deep/ .el-dialog__body {
  //   max-height: 600px;

  // }
  /deep/ .el-form {
    max-height: 600px;
    overflow-y: auto;
  }
}
.tipBox {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.imgList {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
